import { useEffect, useState } from "react";
import Login from '../Login/Login';
import InfoPage from '../InfoPage/InfoPage';
import amplifyconfig from '../../amplifyconfiguration.json';
import Swal from 'sweetalert2';
import awsmobile from '../../aws-exports';
import { Amplify,API} from "aws-amplify";

Amplify.configure(amplifyconfig);
Amplify.configure(awsmobile);

export default function LandingPage(){
    const [isContestFinished, setContestFinished] = useState(true);
    const [contestURL, setContestURL] = useState("");
    const [contestName, setContestName] = useState("");
    const [contestLogo, setContestLogo] = useState("");
    const [isLoader, setIsLoader] = useState(true);
    const [Loader, setLoader] = useState("loader");
    const contestId = "2024_01_32777";
    useEffect(function(){
        CheckContestStatus(contestId);
    },[]) /**Triggered only rendering */
    
  async function CheckContestStatus(contestId){ 
    const apiName = "contestAPI";
    const path = "/contest/details";
    const init = {
      response : true,
      queryStringParameters : {
        contestId
      }
    };
    API.get(apiName, path, init).then(response=>{
       const responseObj = response.data;
       if(responseObj.status === 200){
        const contestDetails = responseObj.contest;
        if(typeof contestDetails.startDate !== "undefined" && typeof contestDetails.endDate !== "undefined"){
           const currentDate = new Date();
           const endDate = new Date(contestDetails.endDate.S);
           const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
           const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
           
           if (endDateOnly < currentDateOnly) {
               setContestFinished(true);
           }else{
               setContestFinished(false);
               
           } 
           setIsLoader(false);
           setLoader("loader page-hide");            
           setContestURL(contestDetails.contestURL.S);
           setContestLogo(contestDetails.logo.S);
           setContestName(contestDetails.contestName.S);
       } 
     }
    }).catch(err=>{
      console.log(err);
      Swal.fire({
          icon: "error",
          title: err.message,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
    });
      
      

    }
   
    return(
       <>
            { isLoader ? <div className={Loader}></div> : !isContestFinished ?
                (<Login contestId={contestId} contestURL={contestURL} contestName={contestName} Logo={contestLogo}/>) 
            : (<InfoPage message="The contest has concluded. Winners will be announced shortly, so stay tuned! Thank you for your active participation, and be sure to watch out for more exciting events and updates in the near future." />)

            } 
        </>
    );
};